/**
 * Notification reducers script file
 *
 * @package    Reducers
 * @author     Vadym Karpenko <vadym.karpenko@door3.com>
 */

import Immutable from 'seamless-immutable';

import {
    ADD_NOTIFY,
    REMOVE_NOTIFY,
} from 'Actions/notifications';

export const INITIAL_STATE = Immutable([]);

export default function notificationReducer (state = INITIAL_STATE, action) {
    switch (action.type) {
        case ADD_NOTIFY: {
            let exists = state.find(({ message, type }) => message === action.data.message && type === action.data.type);

            if (!exists) {
                return state.concat(action.data);
            } else {
                return state;
            }
        }

        case REMOVE_NOTIFY:
            return state.filter(({ id }) => id !== action.id);

        default:
            return state;
    }
}
